import { appendPreferences } from "utils/preferenceBuilder";

const createDetailsFormData = (organization) => {
  
  const {title, slug, description, preferences, logo_file, cover_image_file, logo_url, cover_image_url} = organization;

  const formData = new FormData();
  
  const fields = [
    {key: "title", value: title},
    {key: "slug", value: slug},
  ]
  
  if (description) {
    fields.push({key: "description", value: description});
  }

  fields.forEach(field => {
    formData.append(field.key, field.value);
  });

  appendPreferences(formData, preferences);

  if (logo_file) {
    formData.append("image[action]", "update");
    formData.append("image[file]", logo_file);
  } else if (!logo_url) {
    formData.append("image[action]", "remove");
  }
  
  if (cover_image_file) {
    formData.append("cover_image[action]", "update");
    formData.append("cover_image[file]", cover_image_file);
  } else if (!cover_image_url) {
    formData.append("cover_image[action]", "remove");
  }

  return formData;
};

export default createDetailsFormData;
